module.exports = __webpack_public_path__ + "media/AUDIO-05.47bb7f6e.mp3";